import React, { createRef, useCallback, useEffect, useRef, useState } from "react";
import classNames from "classnames";
import { mobileIs } from "../../utils/siteUtils";
import Image from "../../elements/image";
import Loader from "../../elements/loader";
import Icon from "../../elements/icon";
import { Text } from "@sitecore-jss/sitecore-jss-react";
import MediaCollectionRows from "./media-collection-rows"
import MediaCollectionModel from "./media-collection-model"

import "./style.scss";
const MediaCollection = props => {
  const { lang, fields, page } = props;
  const isAR = page?.fields?.rtl?.value;
  const rootEl = useRef(null);
  const { rows, title, titleMobile, des, desMobile, titleSize, desSize, paddingAboveBottom, paddingAboveTop } = fields;
  const [modelsData, setModelsData] = useState([]);
  const [modelShowIndex, setModelShowIndex] = useState(0);
	const [loadedItem,setLoadedItem] = useState({})
  const [modelShow, setModelShow] = useState(false);
  const [modelHide, setModelHide] = useState(false);
  const [total, setTotal] = useState(3);
  const isMobile = mobileIs();

  const handleOnLoaded = (id) => {
		let newData = loadedItem;
		newData[id] = id;
		setLoadedItem(newData);
    if( Object.keys(loadedItem).length == total ){
        let winHeight = window.innerHeight || document.documentElement.clientHeight
        let dom = rootEl.current.getBoundingClientRect()
        if( Math.abs(dom.top) > dom.height-winHeight ){
            setTotal(total+3)
        }
    }
  }
  const handleScroll = e => {
    let winHeight = window.innerHeight || document.documentElement.clientHeight
    let dom = rootEl.current.getBoundingClientRect()
    if( Math.abs(dom.top) > dom.height-winHeight ){
      var arr = Object.keys(loadedItem)
      if( arr.length == total){
        setTotal(total+3)
      }
      if( total>rows.length || total === rows.length){
        window.removeEventListener("scroll", handleScroll);
      }
    }
  };
  const showModel = (id) => {
    window.scrollBody= document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
    document.body.style.overflowY = "hidden";
    document.body.style.position = "fixed";
    setModelShow(true)
    modelsData.forEach((item,index)=>{
      if(id === item.itemId){
        setModelShowIndex(index)
      }
    })
  }
  const closeModel = () => {
    document.getElementById('modelEl').scrollTop = 0
    document.body.style.position = "relative";
    document.body.style.overflowY = "auto";
    window.scrollTo(window.scrollBody,window.scrollBody); 
    stopVideo()
    setModelHide(true)
    setTimeout(v=>{
      setModelShow(false)
      setModelHide(false)
    },150)
    document.getElementsByTagName('html')[0].classList.remove("modal-open")
  }
  const prevModel = () => {
    stopVideo()
    if( modelShowIndex === 0 ){
      setModelShowIndex(modelsData.length-1)
    } else {
      setModelShowIndex(modelShowIndex-1)
    }
  }
  const nextModel = () => {
    stopVideo()
    if( modelShowIndex === modelsData.length-1 ){
      setModelShowIndex(0)
    } else {
      setModelShowIndex(modelShowIndex+1)
    }
  }
  const stopVideo = () => {
    if(document.getElementById('videoMediaModel'+modelShowIndex)){
      document.getElementById('videoMediaModel'+modelShowIndex).getElementsByTagName('video')[0].pause()
    }
  }
  useEffect( v=> {
    let data = []
    rows.forEach(row => {
      if(row.fields){
        row.fields.items.forEach(item => {
          if(item.fields && item.fields.models){
            item.fields.models.itemId = item.id
            data.push(item.fields.models)
          }
        })
      }
    });
    // console.log(data)
    setModelsData(data)
  },[])
  useEffect(() => {
      window.addEventListener("scroll", handleScroll);
      return () => {
          document.body.style.position = "relative";
          window.removeEventListener("scroll", handleScroll);
      };
  }, []);
  let top = paddingAboveTop ? paddingAboveTop.fields.phrase.value : "none",
  bottom = paddingAboveBottom ? paddingAboveBottom.fields.phrase.value : "none",
  size = titleSize ? titleSize?.fields?.phrase?.value : "default",
  otherSize = desSize ? desSize?.fields?.phrase?.value : "default";
  const mediaClasses = classNames("padding-top-" + top, "padding-bottom-" + bottom);
  return (
    <div className={classNames("c-media-collection grid",mediaClasses)} ref={rootEl}>
      <div className="c-media-collection__layout">
        { ((isMobile && titleMobile.value) || (!isMobile && title.value)) &&
          <Text tag="div" className={classNames("c-media-collection__title __ff-lk-tp-b type-h1",size)} field={isMobile ? titleMobile: title} /> 
        }
        { ((isMobile && desMobile.value) || (!isMobile && des.value)) &&
          <Text tag="div" className={classNames("type-h1 c-media-collection__des",otherSize)} field={isMobile ? desMobile: des} /> 
        }
        <div className="c-media-collection__list">
          {rows.map((row,index)=>(
            <div key={index}>
            {
              total > index &&
              <div className={classNames('c-media-collection__rows',{three : isMobile && row.fields.items.length === 3 },{two : isMobile && row.fields.items.length === 2 })} >
                <MediaCollectionRows row={row.fields} id={row.id} showModel={showModel} handleOnLoaded={handleOnLoaded}/>
              </div>
            }
            </div>
          ))}
        </div>
        <div className={classNames('c-media-collection__mask',{show: modelShow,hide: modelHide})}></div>
        <div className={classNames('c-media-collection__models',{show: modelShow,hide: modelHide})} id='modelEl'>
          {
            modelsData.map((item,index)=>(
              <div key={index} className={classNames({show: index === modelShowIndex})}>
              { item.fields && index === modelShowIndex &&
                <div className={classNames('c-media-collection__models-item',{show: index === modelShowIndex})} key={index}> 
                  <MediaCollectionModel data={item.fields} index={index}/>
                  <Icon name="SwiperLeft" onClick={ isAR ? nextModel : prevModel} className="c-media-collection__models-item-left" />
                  <Icon name="SwiperRight" onClick={ isAR? prevModel : nextModel} className="c-media-collection__models-item-right" />
                </div>
                }
              </div>
            ))
          }
          <Icon name="Close" onClick={closeModel} className="c-media-collection__models-close"/>
        </div>
        { total < rows.length && 
          <Loader />
        }
      </div>
    </div>
  )
};
export default MediaCollection;
